import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppUserService } from '@ceres/shared/services';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class RolePermissionGuard implements CanActivate {
    private appUserService = inject(AppUserService);
    private router = inject(Router);

    canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        return this.appUserService.permissions$.pipe(
            map((permissions) => {
                if (!next.data.permission || !permissions) {
                    return this.router.createUrlTree(['/unauthorized']);
                }

                const isArray = Array.isArray(next.data.permission);
                if (isArray) {
                    let hasPermission = false;
                    for (const permission of next.data.permission) {
                        if (permissions.has(permission)) {
                            hasPermission = true;
                            break;
                        }
                    }

                    return hasPermission ? true : this.router.createUrlTree(['/unauthorized']);
                } else {
                    return permissions.has(next.data.permission) ? true : this.router.createUrlTree(['/unauthorized']);
                }
            })
        );
    }
}
